/**
 * UTILITAIRES POUR LA GESTION DES ÉVÉNEMENTS
 * Centralise toutes les fonctions réutilisables pour les événements OST
 */

import { getEventStatus } from "./formatters";
import { getStatusClass } from "./orderUtils";



/**
 * Vérifie si un événement peut être distribué
 * @param {Object} event - Événement à vérifier
 * @returns {boolean} True si distribuable
 */
export const canDistributeEvent = (event) => {
  const displayStatus = getEventStatus(event);
  return displayStatus === "Pending";
};

/**
 * Récupère le statut affichable et la classe CSS pour un événement
 * @param {Object} event - Événement
 * @returns {Object} { displayStatus, statusClass }
 */
export const getEventDisplayInfo = (event) => {
  const displayStatus = getEventStatus(event);
  const statusClass = getStatusClass(displayStatus);
  
  return { displayStatus, statusClass };
};